<template lang="pug">
.cp-server-list
  ul.fix
    li.item.fl(v-for="v in list")
      icon(:iconClass="v.iconClass")
      span {{v.lable}}
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      list: [
        { iconClass: 'iconGroup4', lable: '7x12小时响应' },
        { iconClass: 'iconGroup3', lable: '1小时解决' },
        { iconClass: 'iconGroup', lable: '实时后台陪护' },
        { iconClass: 'iconGroup1', lable: '每周效果回访' },
        { iconClass: 'iconGroup5', lable: '每日任务质检' },
        { iconClass: 'iconGroup2', lable: '单月效果优化' },
      ]
    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="stylus">
.cp-server-list
  width 480px
  background url('../../../assets/dun.png') center / 100% no-repeat
  .item
    width 240px
    height 150px
    padding-left 41px
    display flex
    justify-content left
    align-items center
    font-size 36px
    span
      margin-left 13px
      font-size 18px
</style>
